<template>
  <el-dialog
    :append-to-body="true"
    :title="type == 'add' ? '新增突发事件' : '修改突发事件'"
    :visible.sync="show"
    direction="ltr"
    :before-close="handleClose"
    size="40%"
    :wrapperClosable="false"
    :close-on-press-escape="false"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="130px"
      class="demo-ruleForm"
    >
      <el-form-item label="学生姓名:" prop="studentName">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.studentName"
          placeholder="请输入学生姓名"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="班级名称:" prop="className">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.className"
          placeholder="请输入班级名称"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否特异体质:" prop="isPeculiar">
        <el-select
          style="width:95%"
          v-model="ruleForm.isPeculiar"
          placeholder="请选择是否特异体质"
          clearable
          size="small"
        >
          <el-option
            v-for="item in $store.state.select.yesOrNo"
            :key="item.id"
            :label="item.nameOne"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="事件等级:" prop="level">
        <el-select
          style="width:95%"
          v-model="ruleForm.level"
          placeholder="请选择事件等级"
          clearable
          size="small"
        >
          <el-option
            v-for="item in $store.state.select.eventLevel"
            :key="item.id"
            :label="item.nameOne"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="处理结果" prop="results">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.results"
          placeholder="请输入处理结果"
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 3 }"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item label="突发时间:" prop="happenTime">
        <el-date-picker
          size="small"
          style="width:95%"
          v-model="ruleForm.happenTime"
          type="date"
          :picker-options="pickerOptions"
          clearable
          value-format="timestamp"
          placeholder="选择突发时间"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="突发情况详情" prop="details">
        <el-input
          style="width:95%"
          v-model.trim="ruleForm.details"
          placeholder="请输入突发情况详情"
          type="textarea"
          :autosize="{ minRows: 1, maxRows: 3 }"
          clearable
          size="small"
        ></el-input>
      </el-form-item>
      <el-form-item size="large">
        <el-button
          type="primary"
          size="small"
          @click="saveForm('ruleForm')"
          v-loading="saveLoading"
          >提交</el-button
        >
        <el-button @click="handleClose" size="small" v-loading="saveLoading"
          >取消</el-button
        >
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
<script>
export default {
  name: "AddOrEditEmergency",
  props: {
    drawerShow: {
      type: Boolean,
      default: {
        return: false
      }
    },
    drawerType: {
      type: String,
      default: {
        return: ""
      }
    },
    initialData: {
      type: Object,
      default: {
        return: {}
      }
    }
  },
  data() {
    return {
      pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
      },
      show: false,
      type: "",
      ruleForm: {
        id: "",
        studentName: "", //学校名称
        className: "", //班级名称
        isPeculiar: 0, //是否特异体质
        results: "", //处理结果
        happenTime: "", //突发时间
        details: "", //突发情况详情
        schoolId: this.$store.state.schoolId
      },
      saveLoading: false,
      rules: {
        studentName: [{ required: true, message: " ", trigger: "blur" }],
        className: [{ required: true, message: " ", trigger: "blur" }],
        isPeculiar: [{ required: true, message: " ", trigger: "change" }],
        results: [{ required: true, message: " ", trigger: "blur" }],
        level: [{ required: true, message: " ", trigger: "change" }],
        happenTime: [{ required: true, message: " ", trigger: "change" }],
        details: [{ required: true, message: " ", trigger: "blur" }]
      }
    };
  },
  mounted() {},
  methods: {
    //   关闭抽屉
    handleClose() {
      this.$emit("handleClose");
    },
    saveForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addOrEditForm();
        } else {
          return false;
        }
      });
    },
    async addOrEditForm() {
      this.saveLoading = true;
      let req = Object.assign({}, this.ruleForm);
      req.happenTime = parseInt(req.happenTime) / 1000;
      if (this.type == "add") {
        delete req.id;
      }
      let res = await this.$Http.addOrEditEmergency(req, true);
      this.saveLoading = false;
      if (res.code == 200) {
        this.$emit("saveData");
      } else {
        this.$message({
          message: res.messsage || "提交失败",
          type: "error"
        });
      }
    }
  },
  watch: {
    drawerShow: function(nval) {
      this.show = nval;
      if (nval) {
        this.type = this.drawerType || "";
        this.ruleForm = Object.assign({}, this.initialData);
      } else {
        this.$refs.ruleForm.resetFields();
      }
    }
  }
};
</script>
